import React, { useRef, useEffect, useState } from "react"
import Link from "./link"
import gsap from 'gsap'
import Contact from "./contact"
import { SwitchTransition,CSSTransition } from "react-transition-group"

const Header = ({ location, ...props }) => {

  const tl = useRef(null)
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {

    tl.current = gsap.timeline({ paused: true });
    tl.current.to('.overlay--background', { opacity: 1, duration: .75, ease: "ease" });
    tl.current.to('.overlay--menu', { height: 'calc(100vh - 100px)', duration: .75, ease: "power3.inOut" }, '-=0.75');
    tl.current.fromTo('.overlay--menu .inner', { opacity: 0 }, { opacity: 1, duration: 1, ease: "power3.inOut" }, '-=0.5');

  }, [])

  useEffect(() => {
    closeMenu()
    setMenuOpen(false)
  }, [location])

  const openMenu = () => {
    tl.current.play();
    document.querySelector('.overlay--menu').classList.add('active');
    document.querySelector('.overlay--background').classList.add('active');

  }

  const closeMenu = () => {
    tl.current.reverse();
    document.querySelector('.overlay--menu').classList.remove('active');
    document.querySelector('.overlay--background').classList.remove('active');
  }

  useEffect(() => {
    if (tl.current) {
      if (menuOpen) {
        openMenu();
      } else {
        closeMenu();
      }
    }
  }, [menuOpen])

  const menuToggle = () => {
    setMenuOpen((state) => !state)
  }

  return (
    <>
      <header style={{ opacity: (location.pathname === '/' ? 0 : 1) }}  {...props} className='masthead'>
        <div className='grid header--grid gap-0 align-center p10'>
          <Link className='link uppercase size-medium mr20 logo--link' to="/">
            <div className='max-125'>
              <div className='logo--main'></div>
            </div>
          </Link>
          <div className='menu text-center'>
            <SwitchTransition>
              <CSSTransition classNames='fade-menu' timeout={750} key={menuOpen}>
                {menuOpen ?
                  <p className='m0 menu--title inline text-grey'>Open Monday - Friday,  09:00 - 17:00</p> :
                  (<div className="menu-links text-medium ">
                    <Link className='link menu-link' activeClassName='active' to="/work">Work</Link>
                    <Link className='link menu-link mr15 ml15' activeClassName='active' to="/services">Services</Link>
                    <Link className='link menu-link' activeClassName='active' to="/contact">Contact</Link>
                  </div>)
                }
              </CSSTransition>
            </SwitchTransition>
          </div>
          <div className='flex w-100 border-box align-bottom justify-right'>
            <div className='flex align-bottom'>
              <div className={'m0 menu--button ' + (menuOpen ? 'active' : '')} onClick={menuToggle} role='presentation' >
                <span className="first" />
                <span className="third" />
                <span className="second" />
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className='overlay--background' onClick={() => setMenuOpen(false)} role='presentation' />
      <div className='overlay--menu'>
        <div className='inner p10'>
          <div className='h-100 flex flex-wrap w-100'>
            <div className='w-100 mta h7 uppercase medium text-center'>
              <Link className='link op-link mb5 block  text-normal' activeClassName='active' to="/work">Work</Link>
              <Link className='link op-link mb5 block text-normal' activeClassName='active' to="/about">About</Link>
              <Link className='link op-link hide mb5 block  text-normal' activeClassName='active' to="/news">News</Link>
              <Link className='link op-link block  text-normal' activeClassName='active' to="/services">Services</Link>
              <Link className='link op-link block  text-normal' activeClassName='active' to="/contact">Contact</Link>
            </div>
            <div className='w-100 mta'>
              <Contact className='text-normal' />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}



export default Header